export function parseIntOrDefault(input: any, defaultValue: number) {
  const asInt = parseInt(input, 10);
  if (asInt.toString() === 'NaN') {
    return defaultValue;
  }
  return asInt;
}
